import { useMemo } from 'react';
import { useGetSubjectList } from '@/services/generatedAPIs';
import type { QuestionLabel } from '@/services/generatedAPIs.schemas';

const EMPTY_LIST: QuestionLabel[] = [];

/**
 * 封装 useGetSubjectList，提供统一的重试和稳定返回结构。
 */
export function useSubjectList() {
  const { data, error, isLoading } = useGetSubjectList({
    swr: {
      errorRetryCount: 3,
      errorRetryInterval: 1000,
      dedupingInterval: 60000,
    },
  });

  const subjectInfos = useMemo(
    () => data?.data?.subjectInfos ?? EMPTY_LIST,
    [data?.data?.subjectInfos]
  );
  const isReady = !isLoading && !error && subjectInfos.length > 0;

  return {
    subjectInfos,
    error,
    isLoading,
    isReady,
  };
}
